import { useEffect, useRef } from "react";
import Markdown from "react-markdown";
import t from "../locales";

export default function InstructionsDialog({ characterKey }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const description = t(`instructions.${characterKey}.description`);

  useEffect(() => {
    dialogRef.current.showModal();
  }, []);

  // The embed iframe can steal focus from the dialog, so we move it back
  function handleBlur() {
    // activeElement is still <body> during blur, so wait until focus has moved
    setTimeout(() => {
      if (!dialogRef.current?.open) return;
      if (!(document.activeElement instanceof HTMLIFrameElement)) return;

      closeRef.current.focus();
    });
  }

  return (
    <dialog
      ref={dialogRef}
      id="instructions-dialog"
      className="dialog dialog--instructions"
      aria-labelledby="instructions-dialog-title"
      closedby="any"
      onBlur={handleBlur}
    >
      <div className="dialog__header">
        <h2 className="dialog__title" id="instructions-dialog-title">
          {t(`instructions.${characterKey}.title`)}
        </h2>
        {description && (
          <div className="dialog__description markdown">
            <Markdown>{description}</Markdown>
          </div>
        )}
      </div>
      <button
        ref={closeRef}
        className="dialog__close"
        type="button"
        command="close"
        commandfor="instructions-dialog"
      >
        <svg
          className="dialog__icon"
          viewBox="0 0 16 16"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M11.7333 12.6667L12.6667 11.7333L8.93333 8L12.6667 4.26667L11.7333 3.33333L8 7.06667L4.26667 3.33333L3.33333 4.26667L7.06667 8L3.33333 11.7333L4.26667 12.6667L8 8.93333L11.7333 12.6667Z" />
        </svg>
        {t("instructions.close")}
      </button>
    </dialog>
  );
}
